import { render } from "./Footer.vue?vue&type=template&id=fb14d554&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=fb14d554&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb14d554"

export default script